$(document).ready(function(){
  
  $("input[name='properties[send the gift card]']").on("change",function(){
    var $selected_val__ = $(this).val();
    if($selected_val__ == "Send as a gift"){
      $(".send_as_gift").slideDown();
      $(".Pick_up_in_Studio_main_div").slideUp();
      $(".Pick_up_in_Studio_main_div input[type='text']").each(function(){
        $(this).val("")
      })
      $("#post_pickup_date").val("")
    }else{
      $(".Pick_up_in_Studio_main_div").slideDown();
      $(".send_post_details").hide();
      $("#post_type_email").hide();
      $(".send_as_gift input[type='radio']").each(function(){
        $(this).prop('checked', false);
      })
      $(".send_as_gift input[type='text']").each(function(){
        $(this).val("")
      })
      $(".send_as_gift").slideUp();
      
    }    
  });
  $("input[name='properties[Post type]']").on("change",function(){
     let $selected_val__ = $(this).val();
     let $another_selected_val__ = "";
    if($("input[name='properties[Email or recipient]']").is(":checked")){
        $another_selected_val__ = $("input[name='properties[Email or recipient]']:checked").val();
    }
    if($selected_val__ == "Post"){
      $(".send_as_main.post_type.after_select.post_selected").css("display","flex");
      $(".after_select.Email_selected input[type='radio']").each(function(){
        $(this).prop('checked', false);
      })
      $(".send_as_main.post_type.after_select.Email_selected").hide();
    }else if($selected_val__ == "Email"){
      $(".send_as_main.post_type.after_select.Email_selected").css("display","flex");
      $(".after_select.post_selected input[type='radio']").each(function(){
        $(this).prop('checked', false);
      })
      $(".send_as_main.post_type.after_select.post_selected").hide();
    }
    $("#post_type_email").slideUp();
    $(".send_post_details").slideUp();
    // if($selected_val__ == "Post" && $another_selected_val__ == "Email to recipient"){
    //   $(".send_post_details").slideDown();
    //   $("#post_type_email").slideUp();
    // }else if($selected_val__ == "Post" && $another_selected_val__ == "Email to you"){
    //   $(".send_post_details").slideDown();
    //   $("#post_type_email").slideUp();
    // }else if($selected_val__ == "Email" && $another_selected_val__ == "Email to recipient"){
    //   $("#post_type_email").slideDown();
    //   $(".send_post_details").slideUp();
    // }else if($selected_val__ == "Email" && $another_selected_val__ == "Email to you"){
    //   $("#post_type_email").slideDown();
    //   $(".send_post_details").slideUp();
    // }
     
  });
  $("input[name='properties[Email or recipient]']").on("change",function(){
    $("#post_type_email").slideDown();
    $(".send_post_details").slideUp();
  });
  $("input[name='properties[Post or recipient]']").on("change",function(){
    $(".send_post_details").slideDown();
    $("#post_type_email").slideUp();
  });
  $("#send_date_as_gift").on("change",function(){
    let $selected_date___ = $(this).val();
    $("#pickup_date").val($selected_date___);
  });
  
})